// Pila de modales abiertos (BaseModal). Solo el de arriba responde a Esc y
// atrapa el foco; el z-index sale de la posición en la pila para que un modal
// abierto encima de otro siempre quede adelante, aunque se haya montado antes.
// El scroll del body se bloquea mientras haya al menos uno abierto.
import { reactive } from 'vue'

const stack = reactive([])
let nextId = 0

const BASE_Z_INDEX = 50

export function createModalId() {
  nextId += 1
  return `modal-${nextId}`
}

export function pushModal(id) {
  if (!stack.includes(id)) stack.push(id)
  document.body.style.overflow = 'hidden'
}

export function removeModal(id) {
  const index = stack.indexOf(id)
  if (index !== -1) stack.splice(index, 1)
  if (stack.length === 0) document.body.style.overflow = ''
}

export function isTopModal(id) {
  return stack.length > 0 && stack[stack.length - 1] === id
}

export function modalZIndex(id) {
  const index = stack.indexOf(id)
  return BASE_Z_INDEX + Math.max(index, 0)
}
